import { Directionality } from '@angular/cdk/bidi';
import { CdkStepper } from '@angular/cdk/stepper';
import { ChangeDetectorRef, ElementRef, Input, Output, ViewChild } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AssessRequestsComponent } from '../assess-requests/assess-requests.component';
import { SubmitRequestComponent } from '../assess-requests/submit-request/submit-request.component';
import { requestFlags, ruleFlags } from '../common/models/PureRuleDetailsModel';
import { recipeModel } from '../common/models/recipeDetailsModel';
import { DataService } from '../common/services/data.service';
import { StandaloneComponent } from '../standalone/standalone.component';
import { WorklistService } from '../worklist/worklist.service';
import { SubmitRequestNonplmComponent } from '../assess-requests/submit-request-nonplm/submit-request-nonplm.component';
import * as _ from 'lodash';
@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
  providers: [{ provide: CdkStepper, useExisting: StepperComponent }]
})
export class StepperComponent extends CdkStepper implements OnInit {
  @ViewChild(StandaloneComponent) stepper: StandaloneComponent;
  @ViewChild(AssessRequestsComponent) stepper1: AssessRequestsComponent;
  @ViewChild(SubmitRequestComponent) stepper2: SubmitRequestComponent;
  @ViewChild(SubmitRequestNonplmComponent) stepper3: SubmitRequestNonplmComponent;
  @ViewChild('stepTabs') stepTabs: ElementRef;
  @ViewChild('stepsTabsWrapper') stepsTabsWrapper: ElementRef;
  @Output() stepperChange = new EventEmitter<any>();
  @Input() componentName: any;
  // dataSvc = new DataService();
  stepLabels = [];
  navigationItems;
  currentTab;
  viewReqFlag;
  editReqFlag;
  createReqFlag;
  requestID;
  requestStatus;
  loadingMsg: string;
  loading = false;
  viewRuleFlag = false;
  editRuleFlag = false;
  creatNonplm = false;
  roleName = '';
  constructor(
    dir: Directionality,
    changeDetectorRef: ChangeDetectorRef,
    private dataSvc: DataService,
    private router: Router,
    private workListService: WorklistService
  ) {
    super(dir, changeDetectorRef);
  }
  /* istanbul ignore next */
  ngOnInit() {
    const roleData = localStorage.getItem('roles');
    const data = roleData.split(',');
    let listRole = [];
    for (const val of data) {
      if (val.toLowerCase().startsWith('fast')) {
        listRole.push(val);
      }
    }
    listRole = _.uniqBy(listRole);
    this.roleName = listRole.join(',');

    console.log(this.router.url);
    this.nonplmRecipydisable();
    // test sonar
    this.stepLabels = [
      'Verify Request',
      'Update Rules',
      'Execute Rules',
      'Submit Report'];
    this.workListService.getRecipeData().subscribe((val: any) => {
      if (val !== null) {
        // Object.assign(recipeModel, val);
        this.requestID = val.requestID;
        // this.requestStatus = val.requestStatus;
        this.workListService.setRequestStatus(val.requestStatus);
      }
    });
    this.workListService.getRequestStatus().subscribe(status => this.requestStatus = status);
    this.dataSvc.getComponentNameSvc.subscribe((val) => {
      if (val) {
        this.componentName = val;
      }
    });
    this.dataSvc.selectedStepValue.subscribe((value) => {
      this.nonplmRecipydisable();
      this.selectedIndex = 0;
      this.selectedIndex = value;
      if (this.selectedIndex === 0) {
        this.createReqFlag = true;
        this.viewReqFlag = false;
        this.editReqFlag = false;
      } else if (this.selectedIndex === 1) {
        this.createReqFlag = true;
        this.viewReqFlag = false;
        this.editReqFlag = false;
      }
    });
    this.dataSvc.viewToEditStepValue.subscribe((value) => {
      if (value === 1) {
        this.viewRuleFlag = false;
        this.editRuleFlag = true;
      }
    });
    if (requestFlags.createRequest === true && this.selectedIndex === 0) {
      this.stepperChange.next(0);
      this.createReqFlag = true;
      this.viewReqFlag = false;
      this.editReqFlag = false;

    } else if (requestFlags.createRequest === true && this.selectedIndex === 1) {
      this.stepperChange.next(1);
      this.createReqFlag = true;
      this.viewReqFlag = false;
      this.editReqFlag = false;

    } else if (requestFlags.viewRequest === true || requestFlags.EditRequest === true) {
      this.selectedIndex = 2;
      this.viewReqFlag = true;
      this.editReqFlag = true;
      this.createReqFlag = false;
      this.stepperChange.next(2);
    }
    if (ruleFlags.viewRule) {
      this.viewRuleFlag = true;
      this.editRuleFlag = false;
    } else if (ruleFlags.editRule) {
      this.editRuleFlag = true;
      this.viewRuleFlag = false;
    }
  }

  get isCloneRule(): boolean {
    const queryReqData = this.router.parseUrl(this.router.url).queryParams.reqData;
    if (!queryReqData) {
      return false;
    }
    try {
      const reqData = JSON.parse(queryReqData);
      return Array.isArray(reqData) && !!reqData[0] && String(reqData[0].AddRuleType).toLowerCase() === 'clone';
    } catch {
      return false;
    }
  }

  nonplmRecipydisable() {
    if (this.router.url === '/assess-requests/create-request-nonplm' || this.router.url === '/assess-requests/submit-request-nonplm') {
      this.creatNonplm = true;
    } else {
      this.creatNonplm = false;
    }
  }

  /* istanbul ignore next */
  onClick(index: number): void {
    const oldSelectedIndex = this.selectedIndex;
    this.selectedIndex = index;
    if (index === 0) {
      this.dataSvc.setSelectedIndexFlag('0');
    } else if (index === 1) {
      this.dataSvc.setSelectedIndexFlag('1');
    } else {
      this.dataSvc.setSelectedIndexFlag('2');
    }
    if (this.selectedIndex !== oldSelectedIndex) {
      this.dataSvc.setSelectedStepprev('1');
      this.stepperChange.next(oldSelectedIndex);
    }
  }
  /* istanbul ignore next */
  viewReportt() {
    this.dataSvc.isViewReportClicked = 'true';
    this.dataSvc.requestStatusForReport = 'Completed';
    this.dataSvc.setComponentName('SubmitReportRA');
    this.loadingMsg = 'Getting FAsT Report';
    const apiurl = environment.APIFAsT + '/reportrequest/' + this.requestID;
    this.loading = true;
    this.workListService.getData(apiurl).subscribe((response1) => {
      if (response1 !== null) {
        const val: any = {
          requestID: response1.requestDisplayID,
          requestStatus: response1.requestStatus
        };
        this.workListService.setRecipeData(val);
        recipeModel.requestDisplayID = response1.requestDisplayID;
        this.dataSvc.completedReport = response1;
        this.dataSvc.setSelectedStep(3);
        setTimeout(() => {
          this.router.navigate(['assess-request-ra/submit-report']);
        }, 500);
      }
      this.loading = false;
    }, (error) => {
      this.loading = false;
    });
  }
}
